import React from 'react';
import './FixedArea.sass';
import vkLogo from '../../images/logo.svg';
import ShopBtn from "../ShopBtn/ShopBtn";
import { RUSTORE_APP_LINK, PLATFORM_IOS, PLATFORM_ANDROID, PWA_LINK } from '../../constants';

import IconRuStoreRu from '../../images/rustore_badge_ru_color_40.svg';
import IconRuStoreEn from '../../images/rustore_badge_en_color_40.svg';
import IconPwa from '../../images/pwa_badge_ru_color_40.svg';

import data from '../../data';

const FixedArea = ({
   fixed: {title, description, ruStoreDescription, pwaDescription},
   forMobile = false,
   showSendLink,
   platform,
}) => {
    const currentYear = new Date().getFullYear();
    const isIOS = platform === PLATFORM_IOS;
    const isAndroid = platform === PLATFORM_ANDROID;
    const isWeb = !isIOS && !isAndroid;

    return (
        <div
            className={`fixedArea ${forMobile ? 'fixedArea--mobile' : ''} ${!showSendLink ? 'fixedArea--withOutLink' : ''}`}
        >
            <div className="fixedArea__container">
                <div className="fixedArea__top">
                    <div className="fixedArea__logo">
                        <img src={vkLogo} alt=""/>
                    </div>
                    <h1 className="fixedArea__title">
                        { title }
                    </h1>
                    <p className="fixedArea__description" dangerouslySetInnerHTML={{__html: description}}></p>
                    <div className="fixedArea__wrap"
                        style={{marginBottom: !showSendLink ? 67 : 20}}
                    >
                       <div className="fixedArea__actions">
                            {(isAndroid || isWeb) && (
                                <div className="fixedArea__action fixedArea__action--rustore">
                                <ShopBtn
                                    href={RUSTORE_APP_LINK}
                                    icon={data.isEng ? IconRuStoreEn : IconRuStoreRu}
                                    type="rustore"
                                    description={ruStoreDescription}
                                />
                                </div>
                            )}
                            {(isIOS || isWeb) && (
                                <div className="fixedArea__action fixedArea__action--apple">
                                <ShopBtn
                                    href={PWA_LINK}
                                    icon={IconPwa}
                                    type="pwa"
                                    description={pwaDescription}
                                />
                                </div>
                            )}
                            </div>
                    </div>
                </div>
                {
                    forMobile
                    ? (
                        <div className="fixedArea__footnote">
                            <div className="fixedArea__footnote-inner">
                                &copy;&nbsp;{currentYear}&nbsp;
                                <a href={`https://${data.hostName}/team`} className="fixedArea__vk" target="_blank" rel="noopener noreferrer">{data.fixed.team}</a>
                            </div>
                        </div>
                      )
                  : (
                      <div className="fixedArea__footer">
                          &copy;&nbsp;{currentYear}&nbsp;
                          <a href={`https://${data.hostName}/team`} className="fixedArea__vk" target="_blank" rel="noopener noreferrer">{data.fixed.team}</a>
                      </div>
                      )
                }
            </div>
        </div>
    );
};

export default FixedArea;
